export default [{
	titulo: 'Plano Pluri Anual',
	icone: 'menu-icon fa fa-caret-right',
	url: '/links/plano-pluri-anual',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]